import React from 'react';

import {Section, SectionProps} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeSection';
import {
  StandardSectionRow,
  StandardSectionRowProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSectionRow';

export type StandardSectionProps = SectionProps & {
  /** Data about the rows to be displayed within this section */
  sectionRows: Array<StandardSectionRowProps>;
};

/**
 * A standard section for a {@link BenchlingNodeV2}. It consumes and updates the context provided by
 * {@link BenchlingNodeV2}.
 * @package
 */
export function StandardSection(props: StandardSectionProps & SectionProps): JSX.Element {
  const {leftHeader, sectionRows, ...restProps} = props;

  return (
    <Section leftHeader={leftHeader} {...restProps}>
      {sectionRows.map((sectionRowProps) => (
        <StandardSectionRow
          key={`${sectionRowProps.primaryText}-${sectionRowProps.secondaryText}`}
          {...sectionRowProps}
        />
      ))}
    </Section>
  );
}
